import { render, staticRenderFns } from "./LicenseKindTable.vue?vue&type=template&id=43345328&scoped=true"
import script from "./LicenseKindTable.vue?vue&type=script&lang=js"
export * from "./LicenseKindTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43345328",
  null
  
)

export default component.exports